import { render } from "./PacksSettings.vue?vue&type=template&id=24678c32&scoped=true"
import script from "./PacksSettings.vue?vue&type=script&lang=js"
export * from "./PacksSettings.vue?vue&type=script&lang=js"

import "./PacksSettings.vue?vue&type=style&index=0&id=24678c32&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24678c32"]])

export default __exports__